import React, { Component } from 'react';
import { connect } from 'react-redux';

import ReactDOM from 'react-dom';

import { setUser } from '../../reducers/userReducer';
import * as overlayingModal from '../../reducers/overlayingModalReducer';
import { saveDocument, removeDocument } from '../../services/upload';
import * as modal from '../../reducers/modalReducer';
// TODO change icon
import {
  BackIcon,
  ThreeDots,
  Crop,
  TrashIcon
} from '../../icons';
import { BODY_TEXT_COLOR, NEGATIVE_COLOR } from '../../config/colors'
import styled from 'styled-components';

import './style.css'
import LinearProgress from 'material-ui/LinearProgress';
import { pushWithQueryParams } from '../../services/uri';
const $ = require("jquery");

const styles = {
  icon: {width: '32px', height: '32px', cursor: 'pointer'},
  actionIcon: {
    width: '24px',
    height: '24px',
    position: 'absolute',
    top: '12px',
    left: '30px'
  }
}

class UpdateNavBar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      menuVisible: false
    }
  }

  componentWillMount() {
    const docType = this.getDocType();
    const {goBack, user: { isID, isRec, isMisc }} = this.props;
    const noId = docType === 'dl' && !isID;
    const noRec = docType === 'rec' && !isRec;
    const noMisc = docType === 'misc' && !isMisc;
    if (noId || noRec || noMisc) goBack(); 
  }

  getHeaderStyle = () => {
    return {background: '#'+this.props.primaryColor, display: this.props.config.configFetched ? '':'none'}
  }

  toggleMenu = () => {
    this.setState({
      menuVisible: !this.state.menuVisible
    });
  }

  updateDoc = () => {
    this.setState({menuVisible: false});
    ReactDOM.findDOMNode(this.refs.fileInput).click();
  }

  handleFile = () => {
    const {
      path,
      saveDocument,
      setUser,
      openUploadSuccess,
      openUploadError
    } = this.props;
    const type = path.substr(path.lastIndexOf('/')+1);
    const file = $('#file')[0].files[0];
    const objectURL = URL.createObjectURL(file);
    if (type === 'dl') {
      saveDocument(file, 'dl').then(() => {
        $('#doc-image').attr('src', objectURL);
        setUser({ isId: true });
        openUploadSuccess();
        $('#file')[0].value = null;
      }).catch((err) => {
        openUploadError();
        $('#file')[0].value = null;
      })
    };
    if (type === 'rec') {
      saveDocument(file, 'rec').then(() => {
        $('#doc-image').attr('src', objectURL);
        setUser({ isRec: true });
        openUploadSuccess();
        $('#file')[0].value = null;
      }).catch((err) => {
        openUploadError();
        $('#file')[0].value = null;
      })
    };
    if (type === 'misc') {
      saveDocument(file, 'misc').then(() => {
        $('#doc-image').attr('src', objectURL);
        setUser({ isMisc: true });
        openUploadSuccess();
        $('#file')[0].value = null;
      }).catch((err) => {
        openUploadError();
        $('#file')[0].value = null;
      })
    };
  }

  getFieldNameFromDocType = (docType) => {
    switch(docType) {
    case 'dl': return 'isId';
    case 'rec': return 'isRec';
    case 'misc': return 'isMisc';
    }
  }

  delete = () => {
    const { goBack, somethingWrong, setUser } = this.props;
    const docType = this.getDocType(); 
    removeDocument(docType)
      .then(res =>{
        if (res.data.resultCode === 'SUCCESS') {
          const fieldName = this.getFieldNameFromDocType(docType);
          setUser({ [fieldName]: false });
          goBack();
        }
        else somethingWrong();
      })
      .catch(e => somethingWrong());
  }

  renderMenu () {
    if (!this.state.menuVisible) return null;
    return (
      <Menu>
        {/*<MenuRow active={true} onClick={this.rename}>
          <Pencil style={styles.actionIcon} color={BODY_TEXT_COLOR}/>
          Rename
        </MenuRow>*/}
        <MenuRow active={true} onClick={this.updateDoc}>
          <Crop style={styles.actionIcon} color={BODY_TEXT_COLOR} />
          Upload
        </MenuRow>
        <MenuRow last={true} active={true} onClick={this.delete}>
          <TrashIcon style={styles.actionIcon} color={BODY_TEXT_COLOR}/>
          Delete
        </MenuRow>
      </Menu>
    )
  }

  renderProgress = () => {
    if (!this.props.upload.inProgress) return null;
    return <LinearProgress color="#8BC027" mode="determinate" value={this.props.upload.progress} />
  }

  getDocType = () => {
    const path = this.props.path;
    return path.substring(path.lastIndexOf("/")+1);
  }
  
  render() {
    const docType = this.getDocType();
    let documentTitle;
    switch (docType) {
      case 'dl':
        documentTitle = 'Driver license';
        break;
      case 'rec':
        documentTitle = 'Recommendation';
        break;
      case 'misc':
        documentTitle = 'Misc document';
        break;
      default:
        documentTitle = 'Your document';
        break;
    }
    return (
      <div>
        <div className="header primary" style={this.getHeaderStyle()}>
          <div className="left">
            <BackIcon style={styles.icon} color={BODY_TEXT_COLOR} onClick={this.props.goBack} />
          </div>
          <DocumentTitle>
            {documentTitle}
          </DocumentTitle>
          <div className="right">
            <ThreeDots style={styles.icon} color={BODY_TEXT_COLOR} onClick={this.toggleMenu} />
          </div>
        </div>
        {this.renderMenu()}
        {this.renderProgress()}
        <input ref="fileInput" type="file" name="file" id="file" onChange={this.handleFile} accept="image/gif, image/jpeg, image/png"/>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    primaryColor: state.config.primaryColor,
    config : state.config,
    path: state.router.location.pathname,
    user: state.user,
    upload: state.upload
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    goBack: () => dispatch(pushWithQueryParams(process.env.PUBLIC_URL + '/account/update')),
    setUser: (user) => dispatch(setUser(user)),
    saveDocument: (file, type) => saveDocument(file, type),
    openUploadSuccess: () => dispatch(modal.openModal({
      modalType: 'UPLOAD_INFO',
      modalProps: {}
    })),
    openUploadError: () => dispatch(modal.openModal({
      modalType: 'UPLOAD_INFO',
      modalProps: {error: true}
    })),
    somethingWrong: () => dispatch(overlayingModal.showModal({
      modalType: 'SOMETHING_WRONG_MODAL',
      modalProps: {}
    }))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(UpdateNavBar);
const DocumentTitle = styled.div `
  color: ${BODY_TEXT_COLOR};
  font-size: 20px;
`;

const Menu = styled.div `
  width: 100%;
  background-color: #fff;
  color: ${BODY_TEXT_COLOR};
  font-size: 16px;
`;

const MenuRow = styled.div `
  padding: 15px 0 15px 70px;
  position: relative;
  cursor: pointer;
  color: ${props => props.active ? BODY_TEXT_COLOR  :  NEGATIVE_COLOR};
  border-bottom: ${props => props.last ? '0' : `1px solid ${NEGATIVE_COLOR}`};
`;


// WEBPACK FOOTER //
// ./src/components/UpdateNavBar/UpdateNavBar.jsx